/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as VentasRouteImport } from "./routes/ventas"
import { Route as ReportesRouteImport } from "./routes/reportes"
import { Route as RegistroRouteImport } from "./routes/registro"
import { Route as PosRouteImport } from "./routes/pos"
import { Route as LoginRouteImport } from "./routes/login"
import { Route as InventarioRouteImport } from "./routes/inventario"
import { Route as FiscalRouteImport } from "./routes/fiscal"
import { Route as ComprasRouteImport } from "./routes/compras"
import { Route as ClientesRouteImport } from "./routes/clientes"
import { Route as CatalogoRouteImport } from "./routes/catalogo"
import { Route as AdminRouteImport } from "./routes/admin"
import { Route as IndexRouteImport } from "./routes/index"

const VentasRoute = VentasRouteImport.update({
  id: "/ventas",
  path: "/ventas",
  getParentRoute: () => rootRouteImport,
} as any)
const ReportesRoute = ReportesRouteImport.update({
  id: "/reportes",
  path: "/reportes",
  getParentRoute: () => rootRouteImport,
} as any)
const RegistroRoute = RegistroRouteImport.update({
  id: "/registro",
  path: "/registro",
  getParentRoute: () => rootRouteImport,
} as any)
const PosRoute = PosRouteImport.update({
  id: "/pos",
  path: "/pos",
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const InventarioRoute = InventarioRouteImport.update({
  id: "/inventario",
  path: "/inventario",
  getParentRoute: () => rootRouteImport,
} as any)
const FiscalRoute = FiscalRouteImport.update({
  id: "/fiscal",
  path: "/fiscal",
  getParentRoute: () => rootRouteImport,
} as any)
const ComprasRoute = ComprasRouteImport.update({
  id: "/compras",
  path: "/compras",
  getParentRoute: () => rootRouteImport,
} as any)
const ClientesRoute = ClientesRouteImport.update({
  id: "/clientes",
  path: "/clientes",
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogoRoute = CatalogoRouteImport.update({
  id: "/catalogo",
  path: "/catalogo",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/admin": typeof AdminRoute
  "/catalogo": typeof CatalogoRoute
  "/clientes": typeof ClientesRoute
  "/compras": typeof ComprasRoute
  "/fiscal": typeof FiscalRoute
  "/inventario": typeof InventarioRoute
  "/login": typeof LoginRoute
  "/pos": typeof PosRoute
  "/registro": typeof RegistroRoute
  "/reportes": typeof ReportesRoute
  "/ventas": typeof VentasRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/admin": typeof AdminRoute
  "/catalogo": typeof CatalogoRoute
  "/clientes": typeof ClientesRoute
  "/compras": typeof ComprasRoute
  "/fiscal": typeof FiscalRoute
  "/inventario": typeof InventarioRoute
  "/login": typeof LoginRoute
  "/pos": typeof PosRoute
  "/registro": typeof RegistroRoute
  "/reportes": typeof ReportesRoute
  "/ventas": typeof VentasRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/admin": typeof AdminRoute
  "/catalogo": typeof CatalogoRoute
  "/clientes": typeof ClientesRoute
  "/compras": typeof ComprasRoute
  "/fiscal": typeof FiscalRoute
  "/inventario": typeof InventarioRoute
  "/login": typeof LoginRoute
  "/pos": typeof PosRoute
  "/registro": typeof RegistroRoute
  "/reportes": typeof ReportesRoute
  "/ventas": typeof VentasRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/admin"
    | "/catalogo"
    | "/clientes"
    | "/compras"
    | "/fiscal"
    | "/inventario"
    | "/login"
    | "/pos"
    | "/registro"
    | "/reportes"
    | "/ventas"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/admin"
    | "/catalogo"
    | "/clientes"
    | "/compras"
    | "/fiscal"
    | "/inventario"
    | "/login"
    | "/pos"
    | "/registro"
    | "/reportes"
    | "/ventas"
  id:
    | "__root__"
    | "/"
    | "/admin"
    | "/catalogo"
    | "/clientes"
    | "/compras"
    | "/fiscal"
    | "/inventario"
    | "/login"
    | "/pos"
    | "/registro"
    | "/reportes"
    | "/ventas"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  CatalogoRoute: typeof CatalogoRoute
  ClientesRoute: typeof ClientesRoute
  ComprasRoute: typeof ComprasRoute
  FiscalRoute: typeof FiscalRoute
  InventarioRoute: typeof InventarioRoute
  LoginRoute: typeof LoginRoute
  PosRoute: typeof PosRoute
  RegistroRoute: typeof RegistroRoute
  ReportesRoute: typeof ReportesRoute
  VentasRoute: typeof VentasRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/ventas": {
      id: "/ventas"
      path: "/ventas"
      fullPath: "/ventas"
      preLoaderRoute: typeof VentasRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/reportes": {
      id: "/reportes"
      path: "/reportes"
      fullPath: "/reportes"
      preLoaderRoute: typeof ReportesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/registro": {
      id: "/registro"
      path: "/registro"
      fullPath: "/registro"
      preLoaderRoute: typeof RegistroRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/pos": {
      id: "/pos"
      path: "/pos"
      fullPath: "/pos"
      preLoaderRoute: typeof PosRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/inventario": {
      id: "/inventario"
      path: "/inventario"
      fullPath: "/inventario"
      preLoaderRoute: typeof InventarioRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/fiscal": {
      id: "/fiscal"
      path: "/fiscal"
      fullPath: "/fiscal"
      preLoaderRoute: typeof FiscalRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/compras": {
      id: "/compras"
      path: "/compras"
      fullPath: "/compras"
      preLoaderRoute: typeof ComprasRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/clientes": {
      id: "/clientes"
      path: "/clientes"
      fullPath: "/clientes"
      preLoaderRoute: typeof ClientesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/catalogo": {
      id: "/catalogo"
      path: "/catalogo"
      fullPath: "/catalogo"
      preLoaderRoute: typeof CatalogoRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin": {
      id: "/admin"
      path: "/admin"
      fullPath: "/admin"
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  CatalogoRoute: CatalogoRoute,
  ClientesRoute: ClientesRoute,
  ComprasRoute: ComprasRoute,
  FiscalRoute: FiscalRoute,
  InventarioRoute: InventarioRoute,
  LoginRoute: LoginRoute,
  PosRoute: PosRoute,
  RegistroRoute: RegistroRoute,
  ReportesRoute: ReportesRoute,
  VentasRoute: VentasRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
